export default __webpack_public_path__ + "static/media/about.7cb0c663.jpg";